import styles from './SectionTitle.module.scss'
import { Link } from '@/types/cms/Link'
import SectionTitleLink from './SectionTitleLink'
import React from 'react'
import { clsx } from 'clsx'

type SectionTitleProps = {
  title: string
  link?: Link
  className?: string
}

const LinkElement = ({ link, children }: { link?: Link; children: React.ReactNode }) => {
  if (!link) {
    return <>{children}</>
  }

  return (
    <SectionTitleLink
      href={link.url}
      target={link.target}
      rel={link.noFollow ? 'nofollow' : undefined}
      className={styles.link}
    >
      {children}
    </SectionTitleLink>
  )
}

const SectionTitle = ({ title, link, className }: SectionTitleProps) => {
  return (
    <h2 className={clsx(styles.title, className)}>
      <LinkElement link={link}>{title ?? link?.name}</LinkElement>
    </h2>
  )
}

export default SectionTitle
